import pako from "pako";

const COMPRESSED_PREFIX = "GZ:";
const CHUNK_SIZE = 8192;

function uint8ArrayToBase64(uint8: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < uint8.length; i += CHUNK_SIZE) {
    const chunk = uint8.subarray(i, i + CHUNK_SIZE);
    binary += String.fromCharCode.apply(null, chunk as unknown as number[]);
  }
  return btoa(binary);
}

function base64ToUint8Array(base64: string): Uint8Array {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function setCompressedItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    try {
      const compressed = pako.deflate(value);
      const base64 = uint8ArrayToBase64(compressed);
      localStorage.setItem(key, COMPRESSED_PREFIX + base64);
    } catch (compressError) {
      console.error(
        "Failed to store compressed data in localStorage:",
        compressError
      );
    }
  }
}

export function getCompressedItem(key: string): string | null {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  if (raw.indexOf(COMPRESSED_PREFIX) === 0) {
    try {
      const base64 = raw.slice(COMPRESSED_PREFIX.length);
      const bytes = base64ToUint8Array(base64);
      const decompressed = pako.inflate(bytes, { to: "string" });
      return decompressed;
    } catch (e) {
      console.error("Failed to decompress localStorage item:", e);
      return null;
    }
  }

  return raw;
}
